export default __webpack_public_path__ + "static/expand-07af3310554559f3c5d472b3311eddc4.png";